angular
  .module('capability-ng-scheduler')
  .controller('calendarPreferencesSyncController', ($scope: ng.IScope) => {
    $scope.execCb = () => {
      $scope.callback();
    };
  })
  .constant('calendarPreferencesSyncDelegateConfiguration', {
    uniqueComponent: 'calendarPreferencesSync',
    vocabulary: {
      exec(this: any, scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {
        this.execCb();
      }
    }
  })
  .directive(
    'calendarPreferencesSync',
    function calendarPreferencesSync(DelegateResponder: any, calendarPreferencesSyncDelegateConfiguration: any) {
      return {
        restrict: 'E',
        replace: false,
        controller: 'calendarPreferencesSyncController',
        scope: {
          callback: '&'
        },
        link: DelegateResponder(
          calendarPreferencesSyncDelegateConfiguration,
          (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => angular.noop
        )
      };
    }
  )
  .service(
    'calendarPreferencesSyncDelegate',
    function calendarPreferencesSyncDelegate(
      this: any,
      DelegateController: any,
      calendarPreferencesSyncDelegateConfiguration: any
    ) {
      DelegateController(this, calendarPreferencesSyncDelegateConfiguration);
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/calendar_preferences_sync/calendar_preferences_sync.ts